<template>
  <div>
    <div id="container-table" class="ts-h-full">
      <ts-loading-banner :loading="loading">
        <table class="table table-hover ui-table">
          <thead>
            <tr>
              <th>{{ $t('paymentTesting.student') }}</th>
              <th>{{ $t('paymentTesting.sex') }}</th>
              <th class="text-left">{{ $t('paymentTesting.dateOfBirth') }}</th>
              <th class="text-left">{{ $t('paymentTesting.subProgram') }}</th>
              <th class="text-left">{{ $t('paymentTesting.studyTime') }}</th>
            </tr>
            <tr>
              <th colspan="8">
                <input
                  v-model="search"
                  type="text"
                  class="form-control"
                  :placeholder="$t('paymentTesting.typeSearch')"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(resource, index) in resources"
              :key="index"
              @dblclick="onPickStudent(resource)"
            >
              <td>{{ resource.full_name_en }}</td>
              <td>{{ resource.gender }}</td>
              <td>{{ resource.date_of_birth }}</td>
              <td>
                {{
                  resource.sub_program
                    ? resource.sub_program.acps_name_foreign
                    : ''
                }}
              </td>
              <td>
                {{ resource.study_time ? resource.study_time.study_time : '' }}
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'

export default {
  name: 'paymentTestingInquiryComponent',
  props: ['value'],
  data() {
    return {
      loading: false,
      search: null,
      resources: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
    this.fetchData()
  },
  methods: {
    fetchData(search) {
      this.loading = true
      this.$store
        .dispatch('paymentTesting/getInquiry', search)
        .then(response => {
          this.resources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onPickStudent(record) {
      this.model.inquiry_id = record.inquiry_id
      this.model.acps_id = record.acps_id
      this.model.student_name = record.full_name_en
    }
  },
  watch: {
    search: debounce(function(value) {
      if (value) {
        this.fetchData(value)
      }
    }, 800)
  }
}
</script>

<style lang="css" scoped>
#container-table {
  max-height: 35vh;
  height: 30vh;
  overflow: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  white-space: nowrap;
}

.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  /* z-index: 999; */
  padding: 5px 15px;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
  cursor: pointer;
  font-size: 12px;
}
</style>
